import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IURLColumn extends ITableColumn {
  Settings: null
}

export interface IURLCell extends ICell {
  settings: null
}

export class URLCell implements IURLCell {
  value: Cell
  settings: null

  constructor(value: Cell, settings: null) {
    this.value = value
    this.settings = settings
  }

  toString(): string {
    if (this.value === null || this.value === undefined) {
      return ''
    }
    let stringVal = this.value?.toString()
    if (!stringVal?.trim()) return ''
    return stringVal
  }

  toCell<T extends Cell>(newValue: T) {
    if (!newValue || typeof newValue !== 'string') {
      this.value = ''
      return this
    }
    this.value = newValue
    return this
  }
}
